var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210C165.228 210 210 165.228 210 110C210 54.7715 165.228 10 110 10C54.7715 10 10 54.7715 10 110C10 165.228 54.7715 210 110 210ZM110 189C154.183 189 190 153.183 190 109C190 64.8172 154.183 29 110 29C65.8172 29 30 64.8172 30 109C30 153.183 65.8172 189 110 189Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 109,
    r: 80,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8Cm);
export default __webpack_public_path__ + "static/media/8cm.3b2ffc50c4a3b6fa3c01e3b866ffe37d.svg";
export { ForwardRef as ReactComponent };